import React, { useEffect, useState,useMemo } from "react";
import { useWebData } from "../context/WebDataContext";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";

// 🔥 1. IMPORTS FOR DB UPDATE
import { db } from "../firebaseConfig";
import { doc, updateDoc } from "firebase/firestore";

function Dashboard({ setNotificationCount }) {
  const { 
      tasks, leads, attendance, leaves, expenses, advances, travelNotes,
      pms, salesReports, orders, serviceCalls, installations, couriers,
      cardRequests, activityPlans, payments, dues, serviceReports,
      loading: contextLoading 
  } = useWebData();

  const [loading, setLoading] = useState(true);

  const [counts, setCounts] = useState({ 
      leads: 0, orders: 0, pending: 0, service: 0,
      pendingTasks: 0, pendingPMS: 0, pendingCouriers: 0, 
      openLeads: 0, totalLeads: 0, pendingOrders: 0, openService: 0,
      pendingPayments: 0 
  });

  const [activities, setActivities] = useState([]);
  const navigate = useNavigate();

  // ❌ REMOVED: localStorage Logic (readIds) ab hat gaya hai

  // --- CONFIGURATION ---
  const collectionsConfig = useMemo(() => [
      { name: "payment_dues", data: dues, type: "Payment Due", color: "#8e44ad", path: "/payment-dues", group: "action", statusMatch: "Open" }, 
      { name: "leaves", data: leaves, type: "Leave Req", color: "#e74c3c", path: "/leaves", group: "action", statusMatch: "Pending" },
      { name: "tasks", data: tasks, type: "Task", color: "#8e44ad", path: "/tasks", group: "action", statusMatch: "Pending" },
      { name: "advances", data: advances, type: "Advance Req", color: "#d35400", path: "/advances", group: "action", statusMatch: "Pending" },
      { name: "expenses", data: expenses, type: "Expense", color: "#2ecc71", path: "/expenses", group: "action", statusMatch: "Pending" },
      { name: "installations", data: installations, type: "Install", color: "#27ae60", path: "/installations", group: "action", statusMatch: "Pending" },
      { name: "card_requests", data: cardRequests, type: "Card Req", color: "#f39c12", path: "/card-requests", group: "action", statusMatch: "Pending" },
      { name: "couriers", data: couriers, type: "Courier", color: "#607d8b", path: "/couriers", group: "action", statusMatch: "Pending" },
      { name: "pms_reports", data: pms, type: "PMS Due", color: "#16a085", path: "/pms", group: "action", statusMatch: "Pending" }, 
      { name: "activity_plans", data: activityPlans, type: "Plan", color: "#34495e", path: "/activity-plan", group: "action", statusMatch: "Planned" },
      { name: "service_reports", data: serviceReports, type: "Svc Report", color: "#c0392b", path: "/service-reports", group: "action", statusMatch: "Pending" }, 
      { name: "orders", data: orders, type: "PO Appr", color: "#e67e22", path: "/orders", group: "action", statusMatch: "Pending" },

      { name: "leads", data: leads, type: "New Lead", color: "#3498db", path: "/leads", group: "leads", statusMatch: "Open" },
      { name: "service_calls", data: serviceCalls, type: "Ticket", color: "#c0392b", path: "/service-calls", group: "service", statusMatch: "Open" },
      
      { name: "travel_notes", data: travelNotes, type: "Travel", color: "#1abc9c", path: "/travel", group: "logs" },
      { name: "attendance", data: attendance, type: "Punch", color: "#2c3e50", path: "/attendance", group: "logs" },
      { name: "sales_reports", data: salesReports, type: "Visit", color: "#d35400", path: "/reports", group: "logs" },
      { name: "payment_collections", data: payments, type: "Money Recvd", color: "#27ae60", path: "/payment-collections", group: "logs" }
  ], [dues, leaves, tasks, advances, expenses, installations, cardRequests, couriers, pms, activityPlans, serviceReports, orders, leads, serviceCalls, travelNotes, attendance, salesReports, payments]);

  // 2. COUNTS ENGINE (Ye Logic B hai - Status Change hone par hi kam hoga)
  useEffect(() => {
    if (contextLoading) return;

    let tempCounts = {
        totalLeads: 0, openLeads: 0,
        pendingOrders: 0, pendingTasks: 0,
        pendingPMS: 0, openService: 0,
        pendingCouriers: 0, totalPending: 0,
        pendingPayments: 0
    };

    if(leads) {
        tempCounts.totalLeads = leads.length;
        tempCounts.openLeads = leads.filter(i => i.status === 'Open' || i.status === 'New').length;
    }
    if(orders) tempCounts.pendingOrders = orders.filter(i => i.status === 'Pending').length;
    if(tasks) tempCounts.pendingTasks = tasks.filter(i => i.status === 'Pending').length;
    if(pms) tempCounts.pendingPMS = pms.filter(i => i.status === 'Pending').length;
    if(serviceCalls) tempCounts.openService = serviceCalls.filter(i => i.status === 'Open').length;
    if(couriers) tempCounts.pendingCouriers = couriers.filter(i => i.status === 'Pending').length;
    if(dues) tempCounts.pendingPayments = dues.filter(i => i.status === 'Open').length;

    // Master Pending Calculation
    collectionsConfig.forEach(col => {
        if (col.group === 'action') {
            const list = col.data || [];
            // 🔥 Count logic remains SAME (Status based)
            tempCounts.totalPending += list.filter(i => i.status === col.statusMatch).length;
        }
    });

    setCounts(tempCounts);
    setLoading(false);
  }, [tasks, leads, orders, pms, serviceCalls, couriers, dues, contextLoading]);

  // 3. FEED ENGINE (Ye Logic A hai - Database 'isRead' check karega)
  useEffect(() => {
    if (contextLoading) return;
    
    let feed = [];
    collectionsConfig.forEach(col => {
        const list = col.data || [];
        list.forEach(item => {
            
            // 🔥 CRITICAL CHANGE: Check Database 'isRead' field
            if (item.isRead === true) return; 

            const isPending = col.statusMatch && item.status === col.statusMatch;
            const isLog = col.group === 'logs';
            
            if (isPending || isLog) {
                let message = `${col.type}: ${item.userName || 'User'}`;
                if(col.name === 'payment_dues') message = `⏳ Payment Due: ${item.orgName} (₹${item.amount})`;
                else if(col.name === 'leads') message = `👤 New Lead: ${item.org}`;
                else if(col.name === 'orders') message = `🛒 PO: ${item.hospitalName} - ₹${item.amount}`;
                else if(col.name === 'tasks') message = `📋 Task: ${item.task}`;
                else if(col.name === 'payment_collections') message = `💰 Recvd: ₹${item.amount} from ${item.orgName}`;
                
                feed.push({ 
                    id: item.id, 
                    type: col.type, 
                    msg: message, 
                    time: item.createdAt || item.date, 
                    path: col.path, 
                    color: col.color,
                    collection: col.name // 🔥 Collection name zaroori hai update ke liye
                });
            }
        });
    });
    feed.sort((a, b) => new Date(b.time || 0) - new Date(a.time || 0));
    setActivities(feed);
    if (setNotificationCount) setNotificationCount(feed.length);
  }, [tasks, leads, attendance, leaves, expenses, advances, travelNotes, pms, salesReports, orders, serviceCalls, installations, couriers, cardRequests, activityPlans, payments, dues, setNotificationCount, contextLoading]);

  // 🔥 CLICK HANDLER: Update Database to 'Read'
  const handleItemClick = async (item) => {
      // 1. Navigate Turant
      navigate(item.path);

      // 2. Database me 'Mark as Read' (Background me)
      try {
          const docRef = doc(db, item.collection, item.id);
          await updateDoc(docRef, { isRead: true });
      } catch (error) {
          console.error("Error marking read:", error);
      }
  };

  const formatTime = (iso) => {
    if(!iso) return "";
    const date = new Date(iso);
    return isNaN(date.getTime()) ? "" : date.toLocaleString('en-GB', {day:'numeric', month:'short', hour:'2-digit', minute:'2-digit'});
  };

  if (loading) return <Loader />;

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2 style={{ color: "#2c3e50", marginBottom:"20px" }}>🚀 Dashboard Overview</h2>

      <div style={gridStyle}>
        
        {/* CARDS SECTION (Pending Counts - Will NOT decrease on click, only on action) */}
        <div onClick={() => navigate('/pending-approvals')} style={{...cardStyle, borderLeft:"5px solid #e74c3c", backgroundColor:"#fff5f5"}}>
            <h3 style={{margin:0, fontSize:"32px", color:"#c0392b"}}>{counts.totalPending}</h3>
            <p style={{margin:0, color:"#c0392b", fontWeight:"bold"}}>⚠️ Master Pending List</p>
            <p style={{fontSize:"10px", color:"gray"}}>Click to view all</p>
        </div>

        <div onClick={() => navigate('/payment-dues')} style={{...cardStyle, borderLeft:"5px solid #8e44ad"}}>
            <h3 style={{margin:0, fontSize:"28px"}}>{counts.pendingPayments}</h3>
            <p style={{margin:0, color:"#8e44ad", fontWeight:"bold"}}>💸 Pending Payments</p>
        </div>

        <div onClick={() => navigate('/leads')} style={{...cardStyle, borderLeft:"5px solid #2980b9"}}>
            <h3 style={{margin:0, fontSize:"28px"}}>{counts.totalLeads}</h3>
            <p style={{margin:0, color:"gray"}}>Total Leads</p>
        </div>

        <div onClick={() => navigate('/leads')} style={{...cardStyle, borderLeft:"5px solid #3498db"}}>
            <h3 style={{margin:0, fontSize:"28px"}}>{counts.openLeads}</h3>
            <p style={{margin:0, color:"#3498db", fontWeight:"bold"}}>Open Leads</p>
        </div>

        <div onClick={() => navigate('/orders')} style={{...cardStyle, borderLeft:"5px solid #e67e22"}}>
            <h3 style={{margin:0, fontSize:"28px"}}>{counts.pendingOrders}</h3>
            <p style={{margin:0, color:"#d35400", fontWeight:"bold"}}>Pending Orders</p>
        </div>

        <div onClick={() => navigate('/service-calls')} style={{...cardStyle, borderLeft:"5px solid #c0392b"}}>
            <h3 style={{margin:0, fontSize:"28px"}}>{counts.openService}</h3>
            <p style={{margin:0, color:"#c0392b", fontWeight:"bold"}}>Open Tickets</p>
        </div>

        <div onClick={() => navigate('/tasks')} style={{...cardStyle, borderLeft:"5px solid #27ae60"}}>
            <h3 style={{margin:0, fontSize:"28px"}}>{counts.pendingTasks}</h3>
            <p style={{margin:0, color:"#27ae60", fontWeight:"bold"}}>Pending Tasks</p>
        </div>

        <div onClick={() => navigate('/couriers')} style={{...cardStyle, borderLeft:"5px solid #607d8b"}}>
            <h3 style={{margin:0, fontSize:"28px"}}>{counts.pendingCouriers}</h3>
            <p style={{margin:0, color:"#607d8b", fontWeight:"bold"}}>Courier Pending</p>
        </div>

      </div>

      {/* NOTIFICATION FEED (Click karne par Permanent Gayab) */}
      <div style={{display:"flex", alignItems:"center", marginBottom:"10px", marginTop:"30px"}}>
          <h3 style={{ color: "#555", margin:0 }}>🔔 Live Activity Feed</h3>
          {activities.length > 0 && <span style={{marginLeft:"10px", background:"red", color:"white", padding:"2px 8px", borderRadius:"10px", fontSize:"12px"}}>{activities.length} New</span>}
      </div>
      
      <div style={{ backgroundColor: "white", borderRadius: "8px", boxShadow: "0 4px 10px rgba(0,0,0,0.05)", maxHeight:"400px", overflowY:"auto" }}>
        {activities.length === 0 ? <p style={{padding:"20px", textAlign:"center", color:"gray"}}>No new updates.</p> : activities.map((item, index) => (
            <div key={index} onClick={() => handleItemClick(item)} style={{display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 20px", borderBottom: "1px solid #f0f0f0", cursor: "pointer"}} onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#f9f9f9"} onMouseOut={(e) => e.currentTarget.style.backgroundColor = "white"}>
                <div style={{display:"flex", alignItems:"center", gap:"15px"}}>
                    <span style={{backgroundColor: item.color, color: "white", padding: "4px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: "bold", minWidth:"90px", textAlign:"center"}}>{item.type}</span>
                    <span style={{fontSize: "14px", fontWeight: "500", color: "#333"}}>{item.msg}</span>
                </div>
                <span style={{fontSize: "11px", color: "#95a5a6", textAlign:"right"}}>{formatTime(item.time)}</span>
            </div>
        ))}
      </div>
    </div>
  );
}

const gridStyle = { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "20px", marginBottom: "30px" };
const cardStyle = { backgroundColor: "white", padding: "20px", borderRadius: "8px", boxShadow: "0 2px 5px rgba(0,0,0,0.1)", textAlign: "center", cursor: "pointer", transition: "0.2s" };

export default Dashboard;